import { HttpErrorResponse } from '@angular/common/http';
import { InsightsDashboard } from '@myrtls/api-interfaces';
import { createAction, props } from '@ngrx/store';

export const resetInsightsState = createAction('[Insights] Reset State');

export const getInsightsDashboardsRequestAction = createAction(
    '[Insights] Get Dashboards Request',
);

export const getInsightsDashboardsSuccessAction = createAction(
    '[Insights] Get Dashboards Success',
    props<{ dashboards: InsightsDashboard[]; url: string }>(),
);

export const getInsightsDashboardsFailureAction = createAction(
    '[Insights] Get Dashboards Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const getInsightsGuestTokenRequestAction = createAction(
    '[Insights] Get Guest Token Request',
);

export const getInsightsGuestTokenSuccessAction = createAction(
    '[Insights] Get Guest Token Success',
    props<{ token: string }>(),
);

export const getInsightsGuestTokenFailureAction = createAction(
    '[Insights] Get Guest Token Failure',
    props<{ error: HttpErrorResponse }>(),
);
